module.exports = __webpack_public_path__ + "img/image-procastinacao.c5c5f2a6.png";